import { render, staticRenderFns } from "./deactivated.vue?vue&type=template&id=4de856f1&"
import script from "./deactivated.vue?vue&type=script&lang=js&"
export * from "./deactivated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports